import moment from 'moment';

const metricsListRealtime = [
  {
    name: 'New Users',
    num: '999.72K',
    subName: '(13:05)',
    percentName1: 'DoD',
    percentName2: 'SDLW',
    percentNum1: '88%',
    percentNum2: '30%',
    date: '2021-01-08 ~ 2021-01-15',
    bubbleNum: '999.23K',
  },
  {
    name: 'Active Users',
    num: '$999.72K',
    subName: '(13:05)',
    percentName1: 'DoD',
    percentName2: 'SDLW',
    percentNum1: '88%',
    percentNum2: '30%',
    date: '2021-01-08 ~ 2021-01-15',
    bubbleNum: '999.23K',
  },
  {
    name: 'Concurrent Users',
    num: '999.72K',
    subName: '(14:00)',
    percentName1: 'DoD',
    percentName2: 'SDLW',
    percentNum1: '88%',
    percentNum2: '30%',
    date: '2021-01-08 ~ 2021-01-15',
    bubbleNum: '999.23K',
  },
  {
    name: 'D2',
    num: '23.2%',
    subName: '(17:00)',
    percentName1: 'DoD',
    percentName2: 'SDLW',
    percentNum1: '88%',
    percentNum2: '30%',
    date: '2021-01-08 ~ 2021-01-15',
    bubbleNum: '999.23K',
  },
  {
    name: 'D3',
    num: '$23.11',
    subName: '(12:00)',
    percentName1: 'DoD',
    percentName2: 'SDLW',
    percentNum1: '88%',
    percentNum2: '30%',
    date: '2021-01-08 ~ 2021-01-15',
    bubbleNum: '999.23K',
  },
  {
    name: 'D7',
    num: '44.3%',
    subName: '(15:10)',
    percentName1: 'DoD',
    percentName2: 'SDLW',
    percentNum1: '88%',
    percentNum2: '30%',
    date: '2021-01-08 ~ 2021-01-15',
    bubbleNum: '999.23K',
  },
];


const tabs = [
  { id: 'users', label: 'Users', pageId: '120001', pageName: 'realtimeIndexUsers', pagePath: '/realtime/index/users' },
  { id: 'revenue', label: 'Revenue', pageId: '120002', pageName: 'realtimeIndexRevenue', pagePath: '/realtime/index/revenue' },
];

const FORM_KEYS = ['time', 'contrastTime', 'zone', 'region', 'system', 'channel']

const INDICATOR_MEANING = ['new_users', 'active_users', 'online_users', 'd2', 'd3', 'd7']
const PC_INDICATOR_MEANING = ['new_users', 'active_users', 'online_users']

const CARD_TYPE = {
  [INDICATOR_MEANING[0]]: {
    title: 'New Users',
    type: 'int'
  },
  [INDICATOR_MEANING[1]]: {
    title: 'Active Users',
    type: 'int'
  },
  [INDICATOR_MEANING[2]]: {
    title: 'Concurrent Users',
    type: 'int'
  },
  // [INDICATOR_MEANING[3]]:{
  //     title: 'Revenue',
  //     type: 'int'
  // },
  [INDICATOR_MEANING[3]]: {
    title: 'D2(T-1)',
    type: 'percent'
  },
  [INDICATOR_MEANING[4]]: {
    title: 'D3(T-2)',
    type: 'percent'
  },
  [INDICATOR_MEANING[5]]: {
    title: 'D7(T-6)',
    type: 'percent'
  }
}

const FORM_MAP = {
  TIME: 'time',
  CONTRAST_TIME: 'contrastDaily',
  SINGLE_TIME: 'singleDaily',
  CONTRAST_DAY: 'contrastDaily',
  ZONE: 'zone',
  REGION: 'region',
  SYSTEM: 'system',
  CHANNEL: 'channel',
  DATA_BY: 'dataBy',
  LANGUAGE: 'language'
}

const RETENTION_INIT_REQ = {
    [FORM_MAP.SINGLE_TIME]: moment().utcOffset(0).format('YYYY-MM-DD'),
    [FORM_MAP.CONTRAST_DAY]: moment().utcOffset(0).subtract(1, 'day').format('YYYY-MM-DD'),
    [FORM_MAP.ZONE]: ['255'],
    [FORM_MAP.REGION]: {
      regions: [],
      markets: ['255'],
      region_type: 'market'
    },
    [FORM_MAP.SYSTEM]: ['255'],
    [FORM_MAP.CHANNEL]: ['255'],
    [FORM_MAP.LANGUAGE]: ['255']
};

// Realtime_Users Data Download 筛选器默认参数
const DATA_DOWNLOAD_REQ = {
  [FORM_MAP.SINGLE_TIME]: moment().utcOffset(0).format('YYYY-MM-DD'),
  [FORM_MAP.ZONE]: ['255'],
  [FORM_MAP.REGION]: {
    regions: [],
    markets: ['255'],
    region_type: 'market'
  },
  [FORM_MAP.SYSTEM]: ['255'],
  [FORM_MAP.CHANNEL]: ['255'],
  [FORM_MAP.LANGUAGE]: ['255']
};

const USERS_TABS: any = {
  USERS: {
    id: "users",
    label: "Users",
  },
  BY_COUNTRY_REGION_ZONE: {
    id: "byCountryRegionZone",
    label: "By country/region/zone",
  },
  CHANGE_ANALYSIS: {
    id: "changeAnalysis",
    label: "Change Analysis",
  },
  DATA_DOWNLOAD: {
    id: "dataDownload",
    label: "Data Download"
  }
};

// new_users_list	[]list	新进用户指标24小时每5分钟一个点
// active_users_list	[]list	活跃用户指标24小时每5分钟一个点
// online_users_list	[]list	在线用户指标24小时每5分钟一个点
// new_users_info	[]info	新进用户国家分布统计
// active_user_info	[]info	活跃用户国家分布统计
// online_user_info	[]info	在线用户国家分布统计
// new_user_last_time	string	新进用户统计最后时间 格式2022-06-01 00:00:00
// active_user_last_time	string	活跃用户统计最后时间 格式2022-06-01 00:00:00
// online_user_last_time	string	在线用户统计最后时间 格式2022-06-01 00:00:00

const INIT_ANALYSIS_DATA ={
  new:{
    tableInfo: [],
    chartList: [],
    lastTime: '',
  },
  active:{
    tableInfo: [],
    chartList: [],
    lastTime:  '',
  },
  online:{
    tableInfo:  [],
    chartList: [],
    lastTime: '',
  },


}
const INIT_RETENTION_DATA = {
  d2:{
    tableInfo:[],
    chartList:[],
    lastTime:''
  },
  d3:{
    tableInfo:[],
    chartList:[],
    lastTime:''
  },
  d7:{
    tableInfo:[],
    chartList:[],
    lastTime:''
  },
}
export {
  FORM_MAP,
  FORM_KEYS,
  CARD_TYPE,
  INDICATOR_MEANING,
  PC_INDICATOR_MEANING,
  INIT_RETENTION_DATA,
  RETENTION_INIT_REQ,
  DATA_DOWNLOAD_REQ,
  metricsListRealtime,
  tabs,
  USERS_TABS,
  INIT_ANALYSIS_DATA
}

export function getContainer(quertStr='') {
  return  document.querySelector(quertStr) || window;
}

export const d2D3D7Arr = ['D2','D3','D7','d2','d3','d7']
